import React from 'react';
import PropTypes from 'prop-types';

export function StatusDot({ done = false, partial = false, label = '' }) {
  const filled = done ? 'done' : partial ? 'partial' : '';
  const stateLabel = done ? 'complete' : partial ? 'partial' : 'incomplete';
  return (
    <span
      className={`onyx-status-dot${filled ? ` onyx-status-dot--${filled}` : ''}`}
      data-testid="onyx-status-dot"
      data-done={done ? 'true' : 'false'}
      data-partial={!done && partial ? 'true' : 'false'}
      title={label}
      aria-label={label ? `${label} ${stateLabel}` : stateLabel}
    />
  );
}

StatusDot.propTypes = {
  done: PropTypes.bool,
  partial: PropTypes.bool,
  label: PropTypes.string,
};
